function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAntragsdaten = function SvgAntragsdaten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2h-4.2a2.96 2.96 0 0 0-5.6 0H2a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V4a2.006 2.006 0 0 0-2-2ZM9 2a1 1 0 0 1 0 2 .945.945 0 0 1-1-1 .945.945 0 0 1 1-1Zm2 14H4v-2h7Zm3-4H4v-2h10Zm0-4H4V6h10Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgAntragsdaten;